

























import { Vue, Component, State, namespace, Prop, Inject } from 'nuxt-property-decorator'
import ExperiencesFilterOptions from '~/components/experience/search-filter/desktop/filter-options.vue'
import { Experience } from '~/types/experience'

import UrlQuery = Experience.UrlQuery

const experience = namespace('experience')

@Component({
  components: {
    ExperiencesFilterOptions
  }
})

export default class ExperienceSearchFilter extends Vue {
  @State klook!: Data.Klook
  @experience.Action setUrlQuery!: Function
  @experience.State urlQuery!: UrlQuery
  @Prop({ default: 'search' }) pageType!: string
  @Inject({ default: (_: any) => _ }) resetPage!: Function

  sort: string = ''

  get sortOptions() {
    const defaultSort = this.pageType === 'search' ? this.$t('5298') : this.$t('7938')
    return [
      { text: defaultSort, type: '' },
      { text: this.$t('13380'), type: 'participants' },
      { text: this.$t('2432'), type: 'review_score' },
      { text: this.$t('13023'), type: 'price' },
      { text: this.$t('15739'), type: 'publish_time' }
    ]
  }

  sortSpm(val: any) {
    return `Sortby_Type.Tab?ext=${JSON.stringify({
      SortBy: val.type || 'most_relevant'
    })}`
  }

  sortChange() {
    this.resetPage && this.resetPage()
    this.setUrlQuery({
      sort: this.sort,
      page: 1
    })
  }

  mounted() {
    this.sort = this.urlQuery.sort || ''
  }
}
